{
  "status": {
    "DRAFT": "مسودة",
    "PENDING_APPROVAL": "بانتظار الموافقة",
    "SUBMITTED": "مقدّم",
    "CERTIFIED": "معتمد",
    "REJECTED": "مرفوض",
    "VOID": "مُبطَل"
  },
  "kind": {
    "INTERIM": "مرحلي",
    "FINAL": "نهائي"
  },
  "stage": {
    "COMPLETION": "عند الاستلام الابتدائي",
    "DLP_END": "نهاية فترة ضمان العيوب",
    "OTHER": "أخرى"
  },
  "actions": {
    "new": "مستخلص جديد",
    "submit": "تقديم",
    "certify": "تسجيل الاعتماد",
    "reject": "تسجيل الرفض",
    "void": "إبطال",
    "delete": "حذف المسودة",
    "sendForApproval": "إرسال للموافقة",
    "reviewApproval": "مراجعة",
    "approveInternal": "اعتماد",
    "returnInternal": "إعادة إلى المسودة"
  },
  "register": {
    "title": "المستخلصات",
    "position": "المعتمد حتى تاريخه {{certified}} من قيمة عقد {{value}} ({{pct}}).",
    "claim": "المستخلص",
    "retention": "المحتجزات",
    "recovery": "استرداد الدفعة المقدمة",
    "penalty": "غرامات التأخير",
    "net": "الصافي",
    "invoice": "الفاتورة",
    "status": "الحالة",
    "actions": "الإجراءات",
    "draftName": "مستخلص (مسودة)",
    "emptyTitle": "لا توجد مستخلصات بعد",
    "empty": "ابدأ أول مستخلص من جدول الكميات.",
    "openClaim": "{{number}} ما زال مفتوحاً: قدّمه أو اعتمده أو ارفضه أو احذفه أولاً.",
    "voidNamed": "إبطال {{number}}",
    "vatLine": "الضريبة {{amount}}",
    "kindPeriod": "{{kind}} · حتى {{date}}",
    "gross": "الإجمالي",
    "groupToDate": "حتى تاريخه",
    "groupCertificate": "هذه الشهادة"
  },
  "newClaim": {
    "title": "مستخلص جديد",
    "description": "تنسخ المسودة كل بنود جدول الكميات الحالي مع ما اعتُمد سابقاً.",
    "kind": "النوع",
    "interimHint": "مستخلص دوري عن الأعمال المنفذة حتى تاريخه.",
    "finalHint": "المستخلص الأخير: يسترد الدفعة المقدمة كاملة.",
    "periodTo": "الفترة حتى",
    "periodToHint": "آخر يوم من الأعمال التي يقيسها هذا المستخلص.",
    "confirm": "بدء المستخلص",
    "done": "بدأت مسودة المستخلص"
  },
  "submit": {
    "title": "تقديم هذا المستخلص؟",
    "body": "يأخذ المستخلص الرقم التالي وتُجمَّد الكميات المطالب بها: صافٍ قدره {{net}} قبل الضريبة يُرسل إلى العميل للاعتماد.",
    "bodyFinal": "يأخذ المستخلص الرقم التالي وتُجمَّد كميات المستخلص النهائي: صافٍ قدره {{net}} قبل الضريبة، ويسترد الدفعة المقدمة كاملة.",
    "confirm": "تقديم المستخلص",
    "done": "قُدّم برقم {{number}}",
    "approvalTitle": "إرسال المستخلص للموافقة؟",
    "approvalBody": "ينتظر الموافقة الداخلية بصافي مطالبة {{net}}. الموافقة الأخيرة ترقّمه وتقدّمه إلى العميل.",
    "approvalConfirm": "إرسال للموافقة",
    "sentForApproval": "أُرسل المستخلص للموافقة الداخلية"
  },
  "reject": {
    "title": "تسجيل رفض {{number}}",
    "body": "لم يعتمد العميل {{number}}. يبقى رقمه مستخدماً، ويقيس المستخلص التالي من آخر شهادة معتمدة.",
    "reason": "سبب العميل",
    "clientRef": "مرجع العميل",
    "confirm": "تسجيل الرفض",
    "done": "رُفض {{number}}"
  },
  "void": {
    "title": "إبطال {{number}}",
    "titlePlain": "إبطال المستخلص",
    "body": "يُبطل هذا الفاتورة {{invoice}} ({{total}}) الصادرة إلى {{customer}} ويعكس قيد الشهادة. يبقى رقم {{number}} مستخدماً، ويقيس المستخلص التالي من الشهادة السابقة.",
    "blockedTitle": "لا يمكن إبطال هذا المستخلص الآن",
    "reason": "السبب",
    "confirm": "إبطال المستخلص",
    "done": "أُبطل {{number}}"
  },
  "delete": {
    "title": "حذف مسودة المستخلص؟",
    "body": "ليس للمسودة رقم بعد، وتُحذف قياساتها معها.",
    "confirm": "حذف المسودة",
    "done": "حُذفت مسودة المستخلص"
  },
  "editor": {
    "title": "المستخلص",
    "back": "العودة إلى المستخلصات",
    "backTo": "مستخلصات {{code}}",
    "ariaTitle": "{{number}} للمشروع {{code}}",
    "periodTo": "الفترة حتى {{date}}",
    "invoice": "الفاتورة {{number}}",
    "noContract": "لا يوجد عقد لهذا المشروع",
    "noContractBody": "تقيس المستخلصات جدول كميات عقد نافذ. أعِدّ العقد في تبويب العقد أولاً.",
    "save": "حفظ المسودة",
    "saveCertified": "حفظ الكميات المعتمدة",
    "saved": "حُفظ المستخلص",
    "saveFailed": "لم يُحفظ المستخلص",
    "noChanges": "لا تغييرات منذ آخر حفظ.",
    "fixRefused_zero": "لا بنود مرفوضة.",
    "fixRefused_one": "صحّح البند الذي يرفضه العقد أولاً.",
    "fixRefused_two": "صحّح البندين اللذين يرفضهما العقد أولاً.",
    "fixRefused_few": "صحّح البنود الـ{{count}} التي يرفضها العقد أولاً.",
    "fixRefused_many": "صحّح البنود الـ{{count}} التي يرفضها العقد أولاً.",
    "fixRefused_other": "صحّح البنود الـ{{count}} التي يرفضها العقد أولاً.",
    "refusedTitle_zero": "لا بنود مرفوضة",
    "refusedTitle_one": "بند واحد لا يمكن المطالبة به كما قيس",
    "refusedTitle_two": "بندان لا يمكن المطالبة بهما كما قيسا",
    "refusedTitle_few": "{{count}} بنود لا يمكن المطالبة بها كما قيست",
    "refusedTitle_many": "{{count}} بنداً لا يمكن المطالبة بها كما قيست",
    "refusedTitle_other": "{{count}} بند لا يمكن المطالبة بها كما قيست",
    "refusedBody": "لا تتجاوز النسبة 100% ولا يكون الرقم سالباً. صحّح البنود المعلّمة لتتمكن من الحفظ.",
    "refusedBodyBlock": "يرفض هذا العقد القياس فوق كمية البند (والنسب فوق 100%). صحّح البنود المعلّمة أو سجّل أمراً تغييرياً للأعمال الإضافية.",
    "warnedTitle_zero": "لا بنود فوق كميتها",
    "warnedTitle_one": "بند واحد مقيس فوق كميته",
    "warnedTitle_two": "بندان مقيسان فوق كميتهما",
    "warnedTitle_few": "{{count}} بنود مقيسة فوق كمياتها",
    "warnedTitle_many": "{{count}} بنداً مقيسة فوق كمياتها",
    "warnedTitle_other": "{{count}} بند مقيسة فوق كمياتها",
    "warnedBody": "يسمح العقد بذلك مع تنبيه. إن وافق العميل على كميات إضافية فالأمر التغييري يُبقي جدول الكميات صحيحاً.",
    "certifiedModeTitle": "أدخل الكميات المعتمدة من العميل",
    "certifiedModeBody": "تبدأ مساوية للمطالب به. غيّر الرقم حيث اعتمد العميل أقل أو أكثر، وأدخل قيمة أو خصماً بالبيسة مع السبب إن اختلفت شهادته.",
    "rejectedTitle": "رفض العميل هذا المستخلص",
    "voidTitle": "أُبطل هذا المستخلص",
    "sheet": "القياس",
    "sheetCertified": "القياس المعتمد",
    "keys": "الأسهم للتنقل بين الأرقام · Enter للتأكيد · Esc للتراجع",
    "noLines": "لا توجد بنود في جدول الكميات الحالي للقياس.",
    "details": "تفاصيل المستخلص",
    "kind": "النوع",
    "periodToLabel": "الفترة حتى",
    "penalty": "غرامات التأخير حتى تاريخه",
    "penaltyHint": "تعويض متفق عليه عن التأخير في الإنجاز، تراكمياً، ويخفض القيمة قبل الضريبة.",
    "manualRecovery": "المسترد من الدفعة المقدمة حتى تاريخه",
    "manualRecoveryHint": "يسترد هذا العقد الدفعة المقدمة بالاتفاق، بحد أقصى قيمة الدفعة.",
    "notes": "ملاحظات",
    "phoneTitle": "افتح على حاسوب لتعديل المستخلصات",
    "phoneBody": "يحتاج قياس المستخلص إلى الجدول كاملاً. هذه أرقامه.",
    "phoneLines_zero": "لا بنود مقيسة حتى تاريخه.",
    "phoneLines_one": "بند واحد مقيس حتى تاريخه.",
    "phoneLines_two": "بندان مقيسان حتى تاريخه.",
    "phoneLines_few": "{{count}} بنود مقيسة حتى تاريخه.",
    "phoneLines_many": "{{count}} بنداً مقيساً حتى تاريخه.",
    "phoneLines_other": "{{count}} بند مقيس حتى تاريخه.",
    "stuckFinalTitle": "ستكون هذه الشهادة الختامية سالبة",
    "stuckFinalBody": "المتبقي من الدفعة المقدمة للاسترداد ({{recovery}}) أكبر من إجمالي هذه الشهادة ({{gross}}). خفّض الدفعة المقدمة بإشعار دائن على فاتورتها، ثم اعتمد الشهادة.",
    "stuckFinalAction": "تخفيض الدفعة المقدمة…",
    "stuckFinalAsk": "يمكن لمن يملك صلاحية فوترة المشروع تخفيضها."
  },
  "grid": {
    "label": "قياس المستخلص",
    "item": "البند",
    "description": "الوصف",
    "unit": "الوحدة",
    "quantity": "كمية العقد",
    "previous": "السابق",
    "applied": "المطالب به",
    "period": "هذه الفترة",
    "cumulative": "التراكمي",
    "certifiedCumulative": "التراكمي المعتمد",
    "rate": "السعر",
    "value": "القيمة حتى تاريخه",
    "byPercent": "نسبة مئوية",
    "cellLabel": "{{column}}، البند {{item}}",
    "overrideNamed": "إدخال قيمة العميل للبند {{item}}",
    "overrideReason": "قيمة العميل: {{reason}}",
    "clientFigure": "رقم العميل",
    "issue": {
      "OVER_MEASURE": "فوق كمية العقد ({{quantity}}): يرفضه العقد.",
      "OVER_MEASUREWarn": "فوق كمية العقد ({{quantity}}).",
      "PERCENT_OVER_100": "أكثر من 100%.",
      "NEGATIVE": "أقل من الصفر."
    }
  },
  "tape": {
    "label": "الشهادة",
    "gross": "الإجمالي حتى تاريخه",
    "previous": "المعتمد سابقاً",
    "period": "هذه الفترة",
    "retention": "المحتجزات {{rate}}",
    "recovery": "استرداد الدفعة المقدمة",
    "penalty": "غرامات التأخير",
    "net": "الصافي",
    "vat": "الضريبة {{rate}}",
    "total": "المستحق",
    "toDate": "حتى تاريخه {{amount}}",
    "clientFigure": "رقم العميل",
    "overrideNamed": "إدخال رقم العميل لـ {{label}}",
    "errors": {
      "NEGATIVE_CERTIFICATE": "صافي هذه الشهادة ليس أكبر من الصفر: الخصومات تتجاوز أعمال الفترة. قِس أعمالاً أكثر أو أجّل الخصومات إلى المستخلص التالي.",
      "RETENTION_BELOW_RELEASED": "ستقل المحتجزات حتى تاريخه عما أُفرج عنه. راجع رقم المحتجزات.",
      "RECOVERY_ABOVE_ADVANCE": "سيتجاوز استرداد الدفعة المقدمة ما فُوتر منها. راجع رقم الاسترداد.",
      "RETENTION_ABOVE_GROSS": "ستتجاوز المحتجزات حتى تاريخه الإجمالي المعتمد حتى تاريخه. راجع رقم المحتجزات."
    },
    "op": {
      "less": "ناقص",
      "equals": "يساوي",
      "plus": "زائد"
    }
  },
  "override": {
    "lineTitle": "قيمة العميل للبند {{item}}",
    "lineBody": "القيمة حتى تاريخه كما اعتمدها العميل، بالبيسة.",
    "retentionTitle": "المحتجزات حتى تاريخه حسب العميل",
    "recoveryTitle": "المسترد من الدفعة حتى تاريخه حسب العميل",
    "deductionBody": "تعطي شروط العقد {{amount}} حتى تاريخه. أدخل رقم العميل إن اختلفت شهادته.",
    "computed": "المحسوب: {{amount}}",
    "amount": "المبلغ حتى تاريخه",
    "reason": "السبب",
    "reasonRequired": "اذكر سبب اختلاف الرقم.",
    "confirm": "اعتماد هذا الرقم",
    "clear": "استخدام الرقم المحسوب"
  },
  "certify": {
    "title": "تسجيل اعتماد {{number}}",
    "description": "شهادة العميل: مرجعها وتاريخها. ينشئ الاعتماد الفاتورة الضريبية.",
    "clientRef": "مرجع شهادة العميل",
    "clientRefHint": "كما في شهادتهم أو خطابهم.",
    "clientRefRequired": "أدخل مرجع العميل.",
    "certifiedOn": "تاريخ الاعتماد",
    "certifiedOnHint": "تُؤرّخ الفاتورة بهذا اليوم.",
    "consequence": "يُصدر هذا فاتورة إلى {{customer}} بمبلغ {{total}} (الضريبة {{vat}})، تستحق في {{due}}، ويرحّل قيد الشهادة ويقفل {{number}}.",
    "refused": "لا يمكن تسجيل هذه الشهادة",
    "previewFailed": "تعذّر إعداد المعاينة",
    "slip": "ما ينشئه الاعتماد",
    "previewStamp": "معاينة",
    "meta": "بتاريخ {{date}} · تستحق {{due}}",
    "net": "الصافي",
    "vat": "الضريبة",
    "total": "الإجمالي",
    "journal": "قيد الشهادة",
    "account": "الحساب",
    "debit": "مدين",
    "credit": "دائن",
    "posts": "تُرحَّل الفاتورة فوراً.",
    "confirm": "تسجيل الاعتماد",
    "retry": "إعادة المحاولة",
    "failed": "لم يُسجَّل الاعتماد",
    "toast": "اعتُمد {{number}}: صدرت الفاتورة {{invoice}}",
    "doneTitle": "اعتُمد {{number}}",
    "doneBody": "اعتُمد {{number}} وصدرت الفاتورة {{invoice}} بمبلغ {{total}} ورُحّلت.",
    "openInvoice": "فتح {{number}}",
    "close": "تم"
  },
  "retention": {
    "title": "المحتجزات",
    "hint": "تُحتجز من كل شهادة حتى الاستلام الابتدائي ونهاية فترة ضمان العيوب، ويُفرج عنها بفاتورة مرحلة بعد مرحلة.",
    "strip": "أرقام المحتجزات",
    "held": "المحتجز",
    "released": "المُفرج عنه",
    "balance": "الرصيد",
    "stages": "مراحل الإفراج",
    "stage": "المرحلة",
    "share": "النسبة",
    "dueOn": "تاريخ الاستحقاق",
    "proposed": "للإفراج",
    "releasedCol": "المُفرج عنه",
    "stageName": "المرحلة {{n}} · {{stage}}",
    "onRequest": "عند الاتفاق",
    "dueStamp": "مستحق",
    "releaseStage": "الإفراج عن المرحلة {{n}}",
    "releaseEarly": "الإفراج المبكر عن المرحلة {{n}}",
    "byCertificate": "المحتجز حسب الشهادة",
    "noCertificates": "لا شيء محتجز بعد: تبدأ المحتجزات مع أول شهادة.",
    "certifiedOn": "تاريخ الاعتماد",
    "period": "هذه الشهادة",
    "toDate": "حتى تاريخه",
    "releases": "الإفراجات",
    "noReleases": "لم يُفرج عن أي محتجزات بعد.",
    "date": "التاريخ",
    "amount": "المبلغ",
    "voidNamed": "إبطال الإفراج {{number}}",
    "pendingTitle": "ستزيد المحتجزات",
    "pending": "{{number}} مفتوح: تصبح المرحلة {{n}} {{amount}} بعد اعتماده."
  },
  "release": {
    "title": "الإفراج عن المحتجزات: {{stage}}",
    "dueBody": "المرحلة مستحقة. يُصدر الإفراج فاتورة بالمبلغ مع الضريبة بنسبة العقد.",
    "earlyBody": "المرحلة غير مستحقة بعد: اذكر سبب الإفراج المبكر.",
    "amountHint": "الرصيد المحتجز: {{balance}}",
    "reason": "سبب الإفراج المبكر",
    "reasonRequired": "اذكر سبب الإفراج قبل الاستحقاق.",
    "confirm": "الإفراج وإصدار الفاتورة",
    "done": "أُفرج عن المحتجزات: صدرت فاتورة بمبلغ {{amount}}",
    "line": "الإفراج عن المحتجزات (المرحلة {{n}}) — {{code}}",
    "voidTitle": "إبطال الإفراج {{number}}",
    "voidBody": "يُبطل هذا فاتورة الإفراج بمبلغ {{amount}}: يعود المبلغ محتجزاً.",
    "voidConfirm": "إبطال الإفراج",
    "voided": "أُبطل الإفراج"
  },
  "advance": {
    "title": "الدفعة المقدمة",
    "hint": "تُفوتر في البداية وتُسترد من كل شهادة، وتُحتسب الضريبة على فاتورة الدفعة المقدمة.",
    "strip": "أرقام الدفعة المقدمة",
    "invoiced": "المفوتر (صافٍ)",
    "recovered": "المسترد",
    "outstanding": "المتبقي",
    "none": "لا توجد دفعة مقدمة مفوترة.",
    "noneProposed": "لا توجد دفعة مقدمة مفوترة. يقترح العقد {{amount}} قبل الضريبة.",
    "issue": "إصدار فاتورة الدفعة المقدمة",
    "issueTitle": "إصدار فاتورة الدفعة المقدمة",
    "issueBody": "دفعة مقدمة واحدة لكل عقد، وتستردها الشهادات وفق العقد.",
    "byPercent": "نسبة",
    "byPercentHint": "من قيمة العقد الأصلية.",
    "byAmount": "مبلغ",
    "byAmountHint": "مبلغ متفق عليه قبل الضريبة.",
    "percent": "نسبة الدفعة",
    "percentHint": "من {{amount}}",
    "amount": "المبلغ قبل الضريبة",
    "confirm": "الإصدار والترحيل",
    "done": "صدرت فاتورة الدفعة المقدمة بمبلغ {{amount}}",
    "line": "الدفعة المقدمة {{pct}} — {{code}}",
    "reducible": "يمكن تخفيض ضمانها إلى {{amount}}.",
    "recoveries": "المسترد حسب الشهادة",
    "noRecoveries": "لم تسترد أي شهادة شيئاً منها بعد.",
    "recoveredCol": "المسترد",
    "void": "إبطال فاتورة الدفعة المقدمة",
    "voidTitle": "إبطال فاتورة الدفعة المقدمة {{number}}",
    "voidBody": "يُبطل هذا {{number}} ({{total}}). يجوز فقط قبل أن تسترد أي شهادة منها.",
    "voidConfirm": "إبطال الدفعة",
    "voided": "أُبطلت {{number}}"
  },
  "money": {
    "invoiceDate": "تاريخ الفاتورة",
    "vatAt": "الضريبة {{rate}}",
    "due": "الاستحقاق",
    "amountRequired": "أدخل مبلغاً أكبر من الصفر.",
    "consequence": "يُصدر هذا فاتورة إلى {{customer}} بمبلغ {{total}} (الضريبة {{vat}})، تستحق في {{due}}.",
    "journal": "القيد"
  },
  "print": {
    "application": "طلب الدفع",
    "certificate": "شهادة الدفع",
    "which": "المستند",
    "back": "العودة إلى {{number}}"
  },
  "printDoc": {
    "certificate": "شهادة دفع مرحلية",
    "finalCertificate": "شهادة الدفع النهائية",
    "application": "طلب دفع (مستخلص)",
    "measurement": "الكميات المنفذة",
    "breakdown": "تفصيل الشهادة",
    "periodTo": "الفترة حتى",
    "submittedOn": "تاريخ التقديم",
    "certifiedOn": "تاريخ الاعتماد",
    "clientRef": "مرجع العميل",
    "contractNo": "رقم العقد",
    "invoice": "الفاتورة الضريبية",
    "client": "العميل",
    "clientReference": "المرجع",
    "project": "المشروع",
    "originalSum": "قيمة العقد الأصلية",
    "variations": "الأوامر التغييرية المعتمدة",
    "currentValue": "قيمة العقد الحالية",
    "item": "البند",
    "toDate": "حتى تاريخه",
    "previous": "السابق",
    "thisPeriod": "هذه الفترة",
    "gross": "إجمالي قيمة الأعمال المنفذة",
    "retention": "المحتجزات",
    "recovery": "استرداد الدفعة المقدمة",
    "penalty": "غرامات التأخير",
    "net": "القيمة الصافية",
    "less": "يُخصم:",
    "vat": "الضريبة {{rate}} على هذه الفترة",
    "amountDue": "المستحق بموجب هذه الشهادة",
    "amountApplied": "المبلغ المطالب به",
    "invoiceLine": "الفاتورة الضريبية {{number}} بتاريخ {{date}}.",
    "signatures": "التواقيع",
    "preparedBy": "أعدّه (المقاول)",
    "certifiedBy": "اعتمده (المهندس)",
    "approvedBy": "وافق عليه (العميل)",
    "submittedBy": "قدّمه (المقاول)",
    "receivedBy": "استلمه (العميل)",
    "companyStamp": "ختم الشركة",
    "nameDate": "الاسم والتاريخ",
    "fixedLine": "المبالغ بالريال العماني (<rial/>)."
  },
  "reconciliation": {
    "title": "مطابقة حسابات العقود",
    "meta": "حسابات العقود في دفتر الأستاذ مقابل أرقام المشاريع. يجب أن يكون كل فرق صفراً.",
    "asOf": "بتاريخ",
    "table": "المطابقة",
    "identityCol": "الحساب",
    "ledger": "دفتر الأستاذ",
    "projects": "المشاريع",
    "difference": "الفرق",
    "other": "قيود أخرى",
    "otherHint": "من خارج المشاريع (مثل القيود اليدوية)",
    "notZero": "ليس صفراً",
    "reconciled": "مطابق",
    "differs": "فرق",
    "allZero": "تتطابق كل حسابات العقود مع المشاريع في {{date}}.",
    "someDiffer_zero": "لا فروق في {{date}}.",
    "someDiffer_one": "حساب واحد مختلف في {{date}}: {{list}}. افتحه لترى المشاريع وراءه.",
    "someDiffer_two": "حسابان مختلفان في {{date}}: {{list}}. افتحهما لترى المشاريع وراءهما.",
    "someDiffer_few": "{{count}} حسابات مختلفة في {{date}}: {{list}}. افتحها لترى المشاريع وراءها.",
    "someDiffer_many": "{{count}} حساباً مختلفاً في {{date}}: {{list}}. افتحها لترى المشاريع وراءها.",
    "someDiffer_other": "{{count}} حساب مختلف في {{date}}: {{list}}. افتحها لترى المشاريع وراءها.",
    "toggle_zero": "{{identity}}: لا مشاريع",
    "toggle_one": "{{identity}}: إظهار مشروع واحد",
    "toggle_two": "{{identity}}: إظهار مشروعين",
    "toggle_few": "{{identity}}: إظهار {{count}} مشاريع",
    "toggle_many": "{{identity}}: إظهار {{count}} مشروعاً",
    "toggle_other": "{{identity}}: إظهار {{count}} مشروع",
    "footnote": "الأرصدة في نهاية {{date}}. أرقام المشاريع من المستخلصات المعتمدة وفواتير الدفعات المقدمة والإفراج عن المحتجزات.",
    "identity": {
      "ADVANCES": "دفعات مقدمة من العملاء",
      "RETENTION": "محتجزات لدى العملاء",
      "REVENUE": "إيرادات العقود"
    },
    "explain": {
      "ADVANCES": "فواتير الدفعات المقدمة (صافٍ) ناقص ما استردته الشهادات",
      "RETENTION": "المحتجزات المعتمدة ناقص الإفراجات",
      "REVENUE": "الإجمالي المعتمد ناقص غرامات التأخير"
    },
    "someDifferOther_zero": "لا فروق في {{date}}.",
    "someDifferOther_one": "حساب واحد مختلف في {{date}}: {{list}}. الفرق من قيود خارج المشاريع (قيود أخرى).",
    "someDifferOther_two": "حسابان مختلفان في {{date}}: {{list}}. الفرق من قيود خارج المشاريع (قيود أخرى).",
    "someDifferOther_few": "{{count}} حسابات مختلفة في {{date}}: {{list}}. الفروق من قيود خارج المشاريع (قيود أخرى).",
    "someDifferOther_many": "{{count}} حساباً مختلفاً في {{date}}: {{list}}. الفروق من قيود خارج المشاريع (قيود أخرى).",
    "someDifferOther_other": "{{count}} حساب مختلف في {{date}}: {{list}}. الفروق من قيود خارج المشاريع (قيود أخرى).",
    "otherLink": "قيود أخرى على {{identity}} في دفتر الأستاذ العام"
  },
  "blocked": {
    "NOT_PERMITTED": "ليست لديك صلاحية لذلك.",
    "ILLEGAL_MOVE": "غير ممكن في حالة هذا المستخلص.",
    "NEGATIVE_CERTIFICATE": "صافي هذه الشهادة ليس أكبر من الصفر.",
    "RETENTION_BELOW_RELEASED": "ستقل المحتجزات حتى تاريخه عما أُفرج عنه.",
    "CLAIM_NOT_LATEST": "يُبطَل آخر مستخلص معتمد فقط، والمستخلص اللاحق يصحح هذا.",
    "CLAIM_HAS_LATER": "يوجد مستخلص لاحق مفتوح: احذفه أو ارفضه أولاً.",
    "RETENTION_RELEASED": "أُفرج عن محتجزات مقابله: الإبطال يجعل المحتجز أقل من المُفرج عنه. أبطِل الإفراج أولاً.",
    "INVOICE_HAS_PAYMENTS": "توجد مقبوضات مخصصة لفاتورته: أزلها من المبيعات أولاً.",
    "SALES_MODULE_OFF": "وحدة المبيعات متوقفة لشركتك، فلا يمكن تغيير أي فاتورة.",
    "FEATURE_OFF": "المستخلصات متوقفة لهذا المشروع.",
    "RECOVERY_ABOVE_ADVANCE": "سيتجاوز الاسترداد الدفعة المقدمة المفوترة.",
    "RETENTION_ABOVE_GROSS": "ستتجاوز المحتجزات الإجمالي المعتمد."
  },
  "errors": {
    "FEATURE_REQUIRES": "فعّل الوظائف التي تحتاجها هذه أولاً (الإعدادات › المشاريع).",
    "CONTRACT_ACTIVE": "العقد نافذ بالفعل.",
    "CONTRACT_NOT_ACTIVE": "فعّل العقد أولاً: تقيس المستخلصات جدول كمياته.",
    "BOQ_REQUIRED": "اختر نسخة جدول كميات للعقد.",
    "CUSTOMER_REQUIRED": "يحتاج المشروع إلى عميل.",
    "BOQ_FROZEN": "لا يمكن تغيير نسخة جدول الكميات هذه.",
    "IMPORT_STALE": "تغيّر جدول الكميات منذ المعاينة: عاين الاستيراد مجدداً.",
    "VARIATION_FROZEN": "يمكن تعديل الأمر التغييري المسودة فقط.",
    "BELOW_CERTIFIED": "ستقل الكمية عما اعتُمد بالفعل.",
    "CLAIM_OPEN": "يوجد مستخلص آخر مفتوح: قدّمه أو اعتمده أو ارفضه أو احذفه أولاً.",
    "FINAL_CERTIFIED": "اعتُمد المستخلص النهائي: لا مستخلصات أخرى على هذا العقد.",
    "CLAIM_NOT_SUBMITTED": "لم يعد المستخلص مقدّماً: أعد تحميله.",
    "OVER_MEASURE": "أحد البنود مقيس فوق كميته، وهذا العقد يرفض ذلك.",
    "PERCENT_OVER_100": "أحد البنود مقيس بأكثر من 100%.",
    "OVERRIDE_REASON_REQUIRED": "اذكر سبباً لكل رقم يختلف عن المحسوب.",
    "NEGATIVE_CERTIFICATE": "صافي هذه الشهادة ليس أكبر من الصفر.",
    "RETENTION_BELOW_RELEASED": "ستقل المحتجزات حتى تاريخه عما أُفرج عنه.",
    "CLAIM_NOT_LATEST": "يُبطَل آخر مستخلص معتمد فقط.",
    "CLAIM_HAS_LATER": "يوجد مستخلص لاحق مفتوح: احذفه أو ارفضه أولاً.",
    "RETENTION_RELEASED": "أُفرج عن محتجزات مقابله: أبطِل الإفراج أولاً.",
    "ADVANCE_EXISTS": "لهذا العقد فاتورة دفعة مقدمة بالفعل.",
    "ADVANCE_RECOVERED": "استردت الشهادات جزءاً من الدفعة المقدمة، فلم يعد بالإمكان إبطال فاتورتها.",
    "RETENTION_EXCEEDS_HELD": "هذا أكثر من المحتجزات المتبقية.",
    "BILLING_BY_CLAIMS": "يفوتر هذا المشروع عقده عبر المستخلصات والدفعة المقدمة والإفراج عن المحتجزات.",
    "GL_ROLE_LINES": "لفاتورة العقد بند واحد يصدره المشروع.",
    "CONTROL_ACCOUNT": "هذا حساب رقابي: تُرحّل إليه مستنداته فقط.",
    "ROLE_ACCOUNT_SHARED": "يحتاج كل دور من أدوار العقود إلى حسابه الخاص: راجع ربط الحسابات.",
    "VERSION_CONFLICT": "غيّر شخص آخر هذا المستخلص في الأثناء: أعد تحميله وأدخل تغييراتك مجدداً.",
    "SALES_MODULE_OFF": "وحدة المبيعات متوقفة لشركتك، فلا يمكن إصدار فواتير.",
    "requestUsed": "استُخدم هذا الطلب لمستند آخر: أغلق النافذة وابدأ من جديد.",
    "RECOVERY_ABOVE_ADVANCE": "سيتجاوز الاسترداد الدفعة المقدمة المفوترة.",
    "RETENTION_ABOVE_GROSS": "ستتجاوز المحتجزات الإجمالي المعتمد.",
    "CERTIFICATE_DATE_ORDER": "هذا التاريخ في المستقبل أو قبل آخر شهادة: اختر تاريخاً بين آخر شهادة واليوم.",
    "CLAIM_NOT_DRAFT": "لم يعد المستخلص مسودة: أعد تحميله.",
    "CLAIM_NOT_CERTIFIED": "يُبطَل المستخلص المعتمد فقط: أعد تحميله.",
    "CONTRACT_NOT_SETTLED": "لا يمكن إغلاق العقد بعد: يوجد مستخلص مفتوح، أو محتجزات لم يُفرج عنها، أو دفعة مقدمة لم تُسترد أو تُخفَّض بالكامل، أو رقم يختلف عن دفتر الأستاذ.",
    "FORFEIT_EXCEEDS_HELD": "هذا أكثر من المحتجزات المتبقية.",
    "REDUCTION_EXCEEDS_OUTSTANDING": "هذا أكثر من المتبقي من الدفعة المقدمة.",
    "SIGNAL_NOT_ACTIVE": "لم يعد هذا التنبيه قائمًا، فلا شيء لتأجيله.",
    "GUARANTEE_CLOSED": "هذا الضمان مُفرج عنه أو مُسيَّل، فلا يمكن تغييره بعد الآن.",
    "GUARANTEE_EVENT_ORDER": "اجعل تاريخ الحدث في تاريخ إصدار الضمان وآخر أحداثه أو بعدهما، ولا يتجاوز اليوم."
  },
  "salesOff": {
    "title": "المبيعات معطلة",
    "body": "لا يمكن إصدار أي فاتورة أو إبطالها، فينتظر الاعتماد والإفراج عن المحتجزات والدفعة المقدمة حتى يفعّل المسؤول المبيعات من الإعدادات › الوحدات. يمكن قياس المستخلصات وتقديمها."
  },
  "explain": {
    "client": "رقم العميل: {{reason}}",
    "noRetention": "لا محتجزات في هذا العقد",
    "cappedOriginal": "بحد أقصى {{cap}}: {{pct}} من قيمة العقد الأصلية",
    "cappedCurrent": "بحد أقصى {{cap}}: {{pct}} من قيمة العقد الحالية",
    "rate": "{{pct}} × {{gross}}",
    "noAdvance": "لا دفعة مقدمة للاسترداد",
    "final": "شهادة نهائية: تسترد ما تبقى من الدفعة المقدمة",
    "proRata": "بالتناسب: الدفعة المقدمة {{advance}} × الإجمالي ÷ قيمة العقد الأصلية {{original}}",
    "proRataCapped": "استُردت الدفعة المقدمة كاملة ({{advance}})",
    "fixed": "{{pct}} من الإجمالي فوق {{threshold}}",
    "fixedNotYet": "يبدأ عندما يتجاوز الإجمالي {{threshold}}",
    "manual": "رقم متفق عليه (استرداد بالاتفاق)",
    "penalty": "غرامات التأخير حتى تاريخه، كما أُدخلت",
    "noPenalty": "لا غرامات تأخير"
  },
  "forfeit": {
    "open": "التنازل عن المحتجزات…",
    "title": "التنازل عن المحتجزات",
    "body": "محتجزات يحتفظ بها العميل نهائيًا مقابل عيوب أو مقاصة. تُرحّلها المشاريع بقيد؛ أبطله من هنا لعكسه.",
    "amount": "المبلغ المتنازل عنه",
    "amountHint": "حتى {{balance}}، وهو المحتجز المتبقي.",
    "date": "التاريخ",
    "reason": "السبب",
    "reasonHint": "سبب احتفاظ العميل بها، مع مرجع خطابه.",
    "reasonRequired": "اذكر السبب.",
    "confirm": "تنازل",
    "consequence": "تنخفض إيرادات العقد وربحه بمبلغ {{amount}}. ويقل ما على العميل بمبلغ {{amount}}، ويبقى {{after}} من المحتجزات. لا يُرسل شيء إلى العميل.",
    "slip": "قيد: التنازل عن المحتجزات",
    "done": "تم التنازل عن {{amount}} من المحتجزات",
    "forfeited": "المتنازل عنه",
    "listTitle": "التنازلات",
    "journalLink": "القيد",
    "voidNamed": "إبطال التنازل عن {{amount}}",
    "voidTitle": "إبطال هذا التنازل",
    "voidBody": "يُعكس القيد ويُحتسب {{amount}} محتجزًا من جديد.",
    "voidConfirm": "إبطال التنازل",
    "voided": "أُبطل التنازل",
    "consequenceEmpty": "تنخفض إيرادات العقد وربحه بالمبلغ المتنازل عنه، ويقل ما على العميل بالقدر نفسه. لا يُرسل شيء إلى العميل."
  },
  "reduce": {
    "open": "تخفيض الدفعة المقدمة…",
    "title": "تخفيض الدفعة المقدمة",
    "body": "إشعار دائن على فاتورة الدفعة المقدمة بضريبة بنسبتها. تصدره المشاريع، فلا تستطيع المبيعات إبطاله: أبطله من هنا.",
    "when": "استخدمه عندما يوافق العميل على استرجاع جزء من الدفعة المقدمة، مثلًا حين يكون المتبقي منها أكبر من إجمالي الشهادة الختامية.",
    "unblocksTitle": "هذا يسمح باعتماد {{number}}",
    "unblocksBody": "المتبقي من الدفعة المقدمة أكبر من إجمالي هذه الشهادة. تخفيض الدفعة المقدمة بمبلغ {{amount}} يتيح للشهادة الختامية استرداد الباقي دون أن تصبح سالبة.",
    "amount": "التخفيض (قبل الضريبة)",
    "amountHint": "حتى {{outstanding}}، وهو المتبقي من الدفعة المقدمة.",
    "date": "التاريخ",
    "reason": "السبب",
    "reasonRequired": "اذكر السبب.",
    "confirm": "إصدار الإشعار الدائن",
    "consequence": "يصدر إلى العميل إشعار دائن بمبلغ {{net}} + الضريبة (الإجمالي {{total}}) على فاتورة الدفعة المقدمة {{invoice}}.",
    "slip": "إشعار دائن على {{invoice}}",
    "done": "صدر إشعار دائن بمبلغ {{amount}}",
    "reduced": "المخفّض",
    "listTitle": "التخفيضات",
    "withVat": "{{total}} شاملة الضريبة",
    "voidNamed": "إبطال الإشعار الدائن {{number}}",
    "voidTitle": "إبطال الإشعار الدائن {{number}}",
    "voidBody": "يُبطَل الإشعار الدائن بمبلغ {{total}} ويرتفع المتبقي من الدفعة المقدمة من جديد.",
    "voidConfirm": "إبطال الإشعار الدائن",
    "voided": "أُبطل التخفيض",
    "stuckTitle": "{{number}} ينتظر تخفيض الدفعة المقدمة",
    "stuckBody": "ستكون الشهادة الختامية سالبة: خفّض الدفعة المقدمة بمبلغ {{amount}} لتسترد الباقي.",
    "consequenceEmpty": "يصدر إلى العميل إشعار دائن بالمبلغ الذي تدخله مضافًا إليه الضريبة، على فاتورة الدفعة المقدمة {{invoice}}.",
    "effect": {
      "owes": "ما زال على تلك الفاتورة {{balance}} غير مدفوع، فيقل ما على العميل بمبلغ {{total}}.",
      "paid": "تلك الفاتورة مدفوعة، فيصبح للعميل {{total}}: رُدّه إليه أو اخصمه من المستخلص التالي.",
      "part": "يسدد الإشعار {{balance}} غير المدفوع على تلك الفاتورة، ويصبح للعميل الباقي {{rest}}: رُدّه إليه أو اخصمه من المستخلص التالي.",
      "unknown": "إذا كانت تلك الفاتورة غير مدفوعة فيقل ما على العميل. وإذا كانت مدفوعة فيصبح للعميل {{total}}: رُدّه إليه أو اخصمه من المستخلص التالي."
    },
    "effectEmpty": {
      "open": "ما زال على تلك الفاتورة {{balance}} غير مدفوع: يقل ما على العميل بقيمة الإشعار حتى هذا المبلغ.",
      "paid": "تلك الفاتورة مدفوعة، فيصبح للعميل إجمالي الإشعار: رُدّه إليه أو اخصمه من المستخلص التالي.",
      "unknown": "إذا كانت تلك الفاتورة غير مدفوعة فيقل ما على العميل؛ وإذا كانت مدفوعة فيصبح للعميل إجمالي الإشعار: رُدّه إليه أو اخصمه من المستخلص التالي."
    }
  }
}
